import { Link } from "react-router-dom";

export interface LinkItem {
  label: string;
  href?: string;
  icon?: React.ReactNode;
  active?: boolean;
  disabled?: boolean;
  onClick?: () => void;
}

export function returnWithActive(
  links: LinkItem[],
  activePage: string,
): LinkItem[] {
  return links.map((link) => ({
    ...link,
    active: link.href === activePage,
  }));
}

export function skudLinks(
  activePage: string,
  lockSelected: boolean,
  onUnlock: () => void,
): LinkItem[] {
  return returnWithActive(
    [
      { label: "Карты доступа", href: "/dashboard/skud" },
      {
        label: "Открыть",
        onClick: onUnlock,
        disabled: !lockSelected,
      },
      {
        label: "Журнал",
        href: "/dashboard/skud/logs",
        disabled: !lockSelected,
      },
      {
        label: "Пароли",
        href: "/dashboard/skud/passcodes",
        disabled: !lockSelected,
      },
    ],
    activePage,
  );
}

export function Links({ links }: { links: LinkItem[] }) {
  return (
    <div className="flex flex-col gap-2 min-w-[240px] max-md:flex-grow quick-actions">
      {links.map((link) => {
        const baseClassName = `flex flex-row items-center gap-4 p-4 rounded-xl font-medium ${
          link.active
            ? "text-primary bg-primary bg-opacity-10"
            : "text-foreground-600"
        } ${link.disabled ? "opacity-50 pointer-events-none cursor-not-allowed" : ""}`;

        if (link.onClick) {
          return (
            <button
              key={link.label}
              onClick={link.disabled ? undefined : link.onClick}
              disabled={link.disabled}
              className={baseClassName}>
              {link.icon}
              {link.label}
            </button>
          );
        }

        return (
          <Link
            to={link.href || "#"}
            key={link.label}
            className={baseClassName}>
            {link.icon}
            {link.label}
          </Link>
        );
      })}
    </div>
  );
}
